import { render } from "./PecOrPeo.vue?vue&type=template&id=3d5ad8ea"
import script from "./PecOrPeo.vue?vue&type=script&lang=js"
export * from "./PecOrPeo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__